import React from "react";
import Image from "next/image";

type QRCodeProps = {
  src: string;
  size: number;
  text: string;
};

const QRCode: React.FC<QRCodeProps> = ({ src, size, text }) => {
  return (
    <div className="mt-8 flex flex-col items-center justify-center">
      <h3
        className="text-center font-regular text-2xl text-black"
        dangerouslySetInnerHTML={{ __html: text }}
      />
      <div className="mt-8 flex items-center justify-center">
        <Image alt="qr code" width={size} height={size} src={src} />
      </div>
    </div>
  );
};

export default QRCode;
